<template lang="pug">
  #GroupPushIndex
    h5.text-center.py-3.letter-spacing-6 客戶篩選結果
    hr.border.border-primary.w-100
    .p-3
      .root(ref="root" :style="rootStyle")
        .viewport(ref="viewport" :style="viewportStyle")
          .spacer(ref="spacer" :style="spacerStyle")
            b-card.border-0.mb-2.customerCard.overflow-hidden.position-relative(
              bg-variant="light",
              v-for="(user,index) in visibleItems",
              :key="user.member_id",
              v-if="memberList"
            )
              i.fas.fa-times-circle.fa-lg.position-absolute.text-danger(
                style="right: 10px;",
                @click="deletePushMemberHandler(user.member_id)"
              )
              label.w-100.mb-0(
                :for="`checkbox-group-${index}`"
              )
                .row.align-items-center.no-gutters
                  .col-4.pr-1
                    ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                      :profileUrl="user.picture_url",
                      :style="{ 'width': '80px', 'height': '80px' }"
                    )
                  .col-8.pl-1
                    p.mb-0.font-weight-bold {{ user.member_chinese_last_name }}{{ user.member_chinese_first_name }}
                    p.mb-0.font-weight-bold 暱稱名 {{ user.member_line_display_name }}
                    p.mb-0 備註名 {{ user.note_name ? user.note_name : '-' }}
            p.mb-0.text-center(
              v-if="!memberList || memberList.length === 0"
            ) 無選擇推播目標
    b-button(
      variant="light",
      block,
      @click="$router.go(-1)",
      class="rounded-0 border-gray border-left-0 border-right-0"
    ) 回上一頁
    ChatGroupPushFooter.outline-none(
      v-if="memberList && memberList.length !== 0",
      @sendHandler="sendHandler"
    )

    SitckerModel(
      title="貼圖",
      @postSendApiHandler="postSendApiHandler"
    )

    TempModel(
      title="訊息模板",
      :multicastPush="true",
      :users="memberList"
    )

    TextPushModel(
      title="群發訊息",
      @sendHandler="sendHandler"
    )
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import ChatGroupPushFooter from '@/components/chat/ChatGroupPushFooter.vue';
import SitckerModel from '@/components/customerModel/stickerModel.vue';
import TextPushModel from '@/components/customerModel/textPushModel.vue';
import TempModel from '@/components/customerModel/tempModel.vue';
import JQuery from 'jquery';

const _ = require('lodash');

const $ = JQuery;
const passiveSupportMixin = {
  methods: {
    // This snippet is taken straight from https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    // It will only work on browser so if you are using in an SSR environment, keep your eyes open
    doesBrowserSupportPassiveScroll() {
      let passiveSupported = false;

      try {
        const options = {
          get passive() {
            // This function will be called when the browser
            //   attempts to access the passive property.
            passiveSupported = true;
            return false;
          }
        };

        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
      } catch (err) {
        passiveSupported = false;
      }
      return passiveSupported;
    }
  }
};

export default {
  name: 'GroupPushIndex',
mixins: [passiveSupportMixin],
  components: {
    ProfilePhotoSticker,
    ChatGroupPushFooter,
    SitckerModel,
    TempModel,
    TextPushModel
  },
data() {
    return {
    // Total height of the root which contains all the list items in px
    rootHeight: 400,
    // Height of each row, give it an initial value but this gets calculated dynamically on mounted
    rowHeight: 100,
    // Current scroll top position, we update this inside the scroll event handler
    scrollTop: 0,
    // Extra padding at the top and bottom so that the items transition smoothly
    // Think of it as extra items just before the viewport starts and just after the viewport ends
    nodePadding: 20
    }
  },
  created() {
    const vm = this;
    $('#home').animate({
      scrollTop: 0
    }, 10);
    vm.$store.commit('toggleLoading', false);
  },
mounted() {
    if (!this.memberList) return;
    this.$refs.root.addEventListener(
      "scroll",
      this.handleScroll,
      this.doesBrowserSupportPassiveScroll() ? { passive: true } : false
    );
    // Calculate that initial row height dynamically
    const largestHeight = this.calculateInitialRowHeight();
    this.rowHeight =
      typeof largestHeight !== "undefined" && largestHeight !== null
        ? largestHeight
        : 30;
  },
  methods: {
    sendHandler(data) {
      const vm = this;
      if (!data || !data.type) return;

      switch (data.type) {
        case 'text':
          vm.postSendApiHandler(data);
          break;
        case 'image':
          vm.$swal.fire({
            title: '請稍候，\n圖片上傳中',
            allowOutsideClick: false,
            heightAuto: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
          // 先上傳圖片, 之後再打 Post Chat Api
          vm.$store.dispatch('sm_chat/saveImgHandler', data.file.file)
            .then((res) => {
              if (res.length === 1) {
                vm.postSendApiHandler({
                  type: 'image',
                  file_id: res[0].data.file_id,
                  image: res[0].data.url
                });
              } else {
                vm.$swal.close();
              }
            });
          break;
        case 'video':
          vm.$swal.fire({
            title: '請稍候，\n影片上傳中',
            allowOutsideClick: false,
            heightAuto: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
           // 先上傳影片, 之後再打 Post Chat Api
          vm.$store.dispatch('sm_chat/saveVideoHandler', data.file.file)
            .then((res) => {
              vm.$swal.close();
              if (res.length === 1) {
                vm.postSendApiHandler({
                  type: 'video',
                  video: res[0].data.url,
                  previewImage: res[0].data.previewImage
                });
              } else {
                vm.$swal.close();
              }
            });
          break;
        default:
          break;
      }
    },
    // 送出訊息
    postSendApiHandler(data) {
      const vm = this;
      // Loding
      vm.$swal.fire({
        title: '請稍候，\n訊息送出中',
        allowOutsideClick: false,
        heightAuto: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const members_uuid = _.map(vm.memberList, (val) => val.member_line_uuid || val.line_uuid);

      vm.$store.dispatch('sm_group_push/multicastSendHandler', {
        to: members_uuid,
        messages: [
          data
        ]
      })
        .then(() => {
          vm.$snotify.success(null, '訊息送出成功');
          vm.$swal.close();
        });
    },
    // 移除要推播的顧客
    deletePushMemberHandler(member_id) {
      const vm = this;
      const key = _.findKey(vm.memberList, (val) => val.member_id === member_id);
      if (!key) return;
      vm.$store.commit('sm_group_push/removeMemberList', key);
    },
    handleScroll(event) {
      this.scrollTop = this.$refs.root.scrollTop;
    },
    /**
    Find the largest height amongst all the children
    Remember each row has to be of the same height
    I am working on the different height version
    */
    calculateInitialRowHeight() {
      const children = this.$refs.spacer.children;
      let largestHeight = 125;
      for (let i = 0; i < children.length; i++) {
        if (children[i].offsetHeight > largestHeight) {
          largestHeight = children[i].offsetHeight;
        }
      }
      return largestHeight;
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sm_group_push.memberList
    }),
    /**
    Total height of the viewport = number of items in the array x height of each item
    */
    viewportHeight() {
      return this.itemCount * this.rowHeight;
    },
    /**
    Out of all the items in the massive array, we only render a subset of them
    This is the starting index from which we show a few items
    */
    startIndex() {
      console.log(this.scrollTop , this.rowHeight , this.nodePadding)
      let startNode =
        Math.floor(this.scrollTop / this.rowHeight) - this.nodePadding;
        console.log(startNode);
        console.log(startNode);
      startNode = Math.max(0, startNode);
      return startNode;
    },
    /**
    This is the number of items we show after the starting index
    If the array has a total 10000 items, we want to show items from say index 1049 till 1069
    visible node count is that number 20 and starting index is 1049
    */
    visibleNodeCount() {
      let count =
        Math.ceil(this.rootHeight / this.rowHeight) + 2 * this.nodePadding;
      count = Math.min(this.itemCount - this.startIndex, count);
      return count;
    },
    /**
    Subset of items shown from the full array
    */
    visibleItems() {
      console.log(this.startIndex, this.visibleNodeCount)
      return this.memberList.slice(
        this.startIndex,
        this.startIndex + this.visibleNodeCount
      );
    },
    itemCount() {
      return this.memberList.length;
    },
    /**
    The amount by which we need to translateY the items shown on the screen so that the scrollbar shows up correctly
    */
    offsetY() {
      return this.startIndex * this.rowHeight;
    },
    /**
    This is the direct list container, we apply a translateY to this
    */
    spacerStyle() {
      return {
        transform: "translateY(" + this.offsetY + "px)"
      };
    },
    viewportStyle() {
      return {
        overflow: "hidden",
        height: this.viewportHeight + "px",
        position: "relative"
      };
    },
    rootStyle() {
      return {
        height: this.rootHeight + "px",
        overflow: "auto"
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    vm.$store.commit('sm_group_push/resetHandler');
    next();
  },
  destroyed() {
    if (!this.memberList) return;
    this.$refs.root.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
